up.compiler('.collapsible', function(collapsible) {
  const link = collapsible.querySelector('.collapsible--link')
  link.addEventListener('click', function() {
    this.parentElement.classList.toggle('-collapsed')
    this.classList.toggle('active', !this.parentElement.classList.contains('-collapsed'))
  })
})
